var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle-icon-container gl-mr-3 gl-mt-2 !gl-self-start"},[_c('gl-icon',{attrs:{"name":_vm.name,"size":24,"variant":"subtle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }